import React, { useState } from 'react';
import { useHistory } from "react-router-dom";
import { ProtocolSection, protocolSectionTarget } from '../../Inventory/Pages/moveDetailNavigation';
import Card from "../../../components/Cards/Card";
import { Col, Row } from 'react-bootstrap';
import { Field } from '../../../components/Common/Field/Field';
import { useTranslation } from 'react-i18next';
import Loader from '../../../components/Common/Loader';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import moment from 'moment';
import { ErrorMessage } from '../../../components/Notifications/Notifications';
import useInventoryCart from '../../Inventory/Hooks/useInventoryCart';
import { MoveTypes } from '../../../api/Inventory/Entities/InventoryMovementEntities';
import { AssignmentType } from '../../../api/Inventory/Entities/InventoryEntities';
import useOperationConfirmation from '../../Inventory/Hooks/useOperationConfirmation';
import { QuantityInput } from '../../Inventory/Shared/QuantityInput';


export function ProtocolDispenseConfirmForm({ match: { params } }) {
    const history = useHistory();
    const { t } = useTranslation();
    const { dispenseId, protocolId } = params
    const [move, isLoading] = useInventoryCart(dispenseId, MoveTypes.ProtocolDispenseRequest.Name, AssignmentType.Protocol.Name, protocolId);
    const [Modal, modalActions] = useOperationConfirmation();
    const [, setRender] = useState(0)

    if (move == null || move.id == 0) return (<Loader isLoading={true}></Loader>)

    const shouldRender = () => setRender(Math.random())

    const handleCancel = () => {
        history.push(protocolSectionTarget(protocolId, ProtocolSection.inventory))
    }

    const handleConfirmationChange = (item, confirmation) => {
        if (confirmation == null) return
        confirmation = parseInt(confirmation)
        try {
            item.confirmQuantity(confirmation)
        } catch (e) {
            ErrorMessage(t('inventory.dispense.invalidConfirmedQuantity'))
        }
        shouldRender()
    }

    const columns = [
        { dataField: 'item.presentation', text: t('commons.description'), headerStyle: { width: '7rem' } },
        { dataField: 'release.lotNumber', text: t('inventory.commons.lotNumber'), headerStyle: { width: '3rem' } },
        { dataField: 'assignment.kitNumber', text: t('inventory.commons.kitNumber'), headerStyle: { width: '3rem' } },
        { dataField: 'quantity', text: t('commons.quantity'), headerStyle: { width: '3rem' } },
        {
            dataField: 'confirmedQuantity', text: 'Confirmada', headerStyle: { width: '3rem' }, formatter: (cell, row) => {
                return (<QuantityInput
                    value={row.confirmedQuantity}
                    min={0}
                    allowEmpty={false}
                    max={row.quantity}
                    onChange={quantity => handleConfirmationChange(row, quantity)} />)
            }
        },

    ]

    async function onHandleSubmit() {
        const areAllZero = move.items.every(x => x.confirmedQuantity == 0)
        if (areAllZero) {
            ErrorMessage("inventory.dispense.atLeastOneConfirmation")
            return
        }

        await modalActions.confirmDispense({
            move: move,
            succeededCallback: () => history.push(protocolSectionTarget(protocolId, ProtocolSection.inventory))
        })
    }

    async function handleCancelMovement() {
        await modalActions.cancelDispenseOperation({
            move,
            succeededCallback: () => history.push(protocolSectionTarget(protocolId, ProtocolSection.inventory))
        })
    }

    return (<>
        <Card
            content={<>
                <Loader isLoading={isLoading}>
                    <div className='text-center'>
                        <label className="info-title info-title-lg">{t('inventory.dispense.protocolDispenseConfirmTitle')}</label>
                    </div>
                    <Row>
                        <Col md={4} sm={12}>
                            <div className="info" style={{ justifyContent: 'space-between!important' }}>
                                <Field title={'ID'} value={move.id} spaceType={'between'} />
                                <Field title={t('commons.type')} spaceType={'between'} value={t(`inventory.movements.moveType.${move.moveType?.toLowerCase()}`)} />
                            </div>
                        </Col>
                        <Col md={4} sm={12}>
                            <div className="info" style={{ justifyContent: 'space-between!important' }}>
                                <Field title={t('commons.status')} spaceType={'between'} value={t('inventory.dispense.pendingOfConfirmation')} />
                                <Field title={t('commons.date')} spaceType={'between'} value={moment(move.createAt).format("DD/MM/YYYY HH:mm")} />
                            </div>
                        </Col>
                        <Col md={4} sm={12}>
                            <div className="info" style={{ justifyContent: 'space-between!important' }}>
                                <Field title={t('commons.patient')} spaceType={'between'}
                                    value={move?.destination?.destinationName}
                                />
                            </div>
                        </Col>
                        <Col sm={12}>
                            <div>
                                <hr />
                                <div className='text-center' style={{ marginTop: "1rem" }}>
                                    <strong className='info-label'>{t('inventory.commons.detail')}</strong>
                                </div>
                                <div style={{ height: '300px', overflow: 'hidden auto' }}>
                                    <BootstrapTable
                                        bordered={false}
                                        hover
                                        remote
                                        keyField='id'
                                        pagination={paginationFactory({
                                            sizePerPage: move?.items?.length ?? 0,
                                            totalSize: move?.items?.length ?? 0,
                                            hideSizePerPage: true
                                        })}
                                        onTableChange={() => { }}
                                        classes="table-spaced table-spaced-small"
                                        wrapperClasses="table-responsive"
                                        data={move.items}
                                        columns={columns}
                                        loading={isLoading}
                                        noDataIndication={() => <>{t("commons.noData")}</>}
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <div style={{ textAlign: 'right', display: 'flex', justifyContent: 'end' }}>
                                <button className="btn btn-secondary" type="button" onClick={handleCancel}>{t('buttons.back')}</button>
                                <button type="button" style={{ marginLeft: '1rem' }} className='btn btn-warning' disabled={false} onClick={handleCancelMovement}>{t('buttons.cancel')}</button>
                                <button type="button" style={{ marginLeft: '1rem' }} className='btn btn-success' disabled={false} onClick={onHandleSubmit}>{t('buttons.finish')}</button>
                            </div>
                        </Col>
                    </Row>
                </Loader>
            </>}
        />
        <Modal />
    </>)
}